// extracted by mini-css-extract-plugin
export default {"btnsec":"CopyRequest_btnsec__613AJ","copy-request-btn":"CopyRequest_copy-request-btn__8EhZH"};